import { render, staticRenderFns } from "./SayfaTanimla.vue?vue&type=template&id=0392796b&"
import script from "./SayfaTanimla.vue?vue&type=script&lang=js&"
export * from "./SayfaTanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports